module.exports = __webpack_public_path__ + "img/25.10.pH.9cddaaa1.png";